module.exports = __webpack_public_path__ + "static/media/tti_reason_1@2x.42da9c8c.png";